import { EventEmitter } from '@angular/core';
var NavItemComponent = /** @class */ (function () {
    function NavItemComponent() {
        this.activated = false;
        this.gotoNavItem = new EventEmitter();
    }
    return NavItemComponent;
}());
export { NavItemComponent };
